import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { addPrefetchLink } from '../../domain/utils/domUtils';
import { domainService } from '../../domain/services/domainService';

// Set up the Db for HTML prefetching
const htmlPrefetchDb = new Set();

const onHovering = href => {
  if (!!href.trim() && !htmlPrefetchDb.has(href)) {
    htmlPrefetchDb.add(href);
    addPrefetchLink(href);
  }
};

export const MPALink = props => {
  const linkProps = { ...props };
  const href = props.to;
  const { children } = props;
  delete linkProps.to;
  delete linkProps.children;

  const ref = useRef(null);

  useEffect(() => {
    let timeoutID;
    const callback = (entries, observer) => {
      if (entries[0].isIntersecting || entries[0].isVisible) {
        timeoutID = setTimeout(() => {
          observer.disconnect();
          if (!htmlPrefetchDb.has(href)) {
            htmlPrefetchDb.add(href);
            // Avoid prefetching under Drupal domains to avoid multiple renders at the same time.
            if (!domainService.isRunningOnCMS()) {
              addPrefetchLink(href);
            }
          }
        }, 2000);
      } else if (timeoutID) {
        clearTimeout(timeoutID);
      }
    };

    let observer;
    // Do not set up an observer for a link pointing to the page we are on.
    if (href !== domainService.removeDomain(window.location.pathname)) {
      observer = new IntersectionObserver(callback);
      observer.observe(ref.current);
    }
    return () => {
      if (observer) {
        observer.disconnect();
        if (timeoutID) {
          clearTimeout(timeoutID);
        }
      }
    };
  }, []);

  return (
    <a
      href={href}
      {...linkProps}
      ref={ref}
      onMouseEnter={() => onHovering(href)}
    >
      {children}
    </a>
  );
};

MPALink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
